import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useCurrentUser } from "hooks/useCurrentUser";

export const ValueWithStaffEditedNotation = ({
  value,
  isEdited,
}: {
  value: React.ReactNode;
  isEdited: boolean;
}): React.ReactNode => {
  const { isStaff } = useCurrentUser();

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {value}
      {isStaff && isEdited && (
        <Typography variant="caption" color="text.disabled" fontStyle="italic">
          edited
        </Typography>
      )}
    </Stack>
  );
};
